import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import store from '../store/store';
import { getFullCalendarEvent } from 'owa-calendar-surface-full-event-locked-store';

export default function getReadEvent(): CalendarEvent {
    return store.viewState ? getFullCalendarEvent(null, store.viewState.itemId) : undefined;
}
